var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGitCommits({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "200px",
    height: "85.333333px",
    viewBox: "0 0 200 85.333333",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.833333,30 L187.5,30 C194.403559,30 200,35.5964406 200,42.5 C200,49.4035594 194.403559,55 187.5,55 L170.833333,55 C163.929774,55 158.333333,49.4035594 158.333333,42.5 C158.333333,35.5964406 163.929774,30 170.833333,30 L170.833333,30 Z",
    fill: "#9CD9AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,30 L29.1666666,30 C36.070226,30 41.6666666,35.5964406 41.6666666,42.5 C41.6666666,49.4035594 36.070226,55 29.1666666,55 L12.5,55 C5.59644063,55 0,49.4035594 0,42.5 C0,35.5964406 5.59644063,30 12.5,30 L12.5,30 Z",
    fill: "#9CD9AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9999998,68.2666665 C114.138489,68.2666665 125.6,56.8051561 125.6,42.6666666 C125.6,28.5281771 114.138489,17.0666667 99.9999998,17.0666667 C85.8615103,17.0666667 74.3999999,28.5281771 74.3999999,42.6666666 C74.3999999,56.8051561 85.8615103,68.2666665 99.9999998,68.2666665 Z M99.9999998,85.333333 C76.4358506,85.333333 57.3333333,66.2308157 57.3333333,42.6666665 C57.3333333,19.1025173 76.4358506,0 99.9999998,0 C123.564149,0 142.666666,19.1025173 142.666666,42.6666665 C142.666666,66.2308157 123.564149,85.333333 99.9999998,85.333333 Z",
    fill: "#2E8F79"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitCommits);
export default __webpack_public_path__ + "static/media/git-commits.9aef4c5a4e2827235c80309c28752ea7.svg";
export { ForwardRef as ReactComponent };